export default {
  methods:{
    /** returns a text translation for the given key */
    tlang : function(key){
      if(!this.$root.translations) return "";
      let translation = this.$root.translations[key];
      if(!translation) return ""
      if(navigator.language.startsWith('zh')){
        return translation.zh || "";
      } else {
        return translation.en || "";
      }
    },
    /** returns an absolute asset URL for the browser language and key */
    alang : function(key){
      if(!this.$root.assets) return "";
      let asset = this.$root.assets[key];
      if(!asset) return ""
      if(navigator.language.startsWith('zh')){
        return `${process.env.VUE_APP_ASSETS_URL}${asset.zh}` || "";
      } else {
        return `${process.env.VUE_APP_ASSETS_URL}${asset.en}` || "";
      }
    }
  }
}
